export default __webpack_public_path__ + "static/media/intro.63cca2dd.png";